<script>
import { mapActions } from 'vuex'
import {
  cartComputed,
  roomsMethods,
  appComputed,
  appMethods,
  cartMethods,
} from '@state/helpers'
import { format as formatDate, addYears } from 'date-fns'

const maxDate = addYears(new Date(), 2)

export default {
  data() {
    return {
      checkInDate: '',
      checkOutDate: '',
      promotionCode: '',
      isMounted: false,
    }
  },
  computed: {
    ...cartComputed,
    ...appComputed,
    pickerOptions() {
      return {
        minDate: new Date(),
        singleDate: false,
        dropdowns: false,
        maxDate,
        secondField: this.$refs.secondField,
        onSelect: this.onSelect,
      }
    },
    checkInPlaceholder() {
      return formatDate(new Date(this.checkInDate), 'DD MMM YYYY')
    },
    checkOutPlaceholder() {
      return formatDate(new Date(this.checkOutDate), 'DD MMM YYYY')
    },
  },
  created() {
    this.checkInDate = this.checkIn
    this.checkOutDate = this.checkOut
    this.promotionCode = this.promoCode
  },
  mounted() {
    // const vm = this
    this.isMounted = true
  },
  methods: {
    ...roomsMethods,
    ...appMethods,
    ...cartMethods,
    ...mapActions(['clearAllCart']),
    // onPickerCheckInChange(date) {
    //   this.checkOutDate = getTommorowDate(date)
    // },
    onSelect(startDate, endDate) {
      if (startDate) this.checkInDate = startDate.format('YYYY-MM-DD')
      if (endDate) this.checkOutDate = endDate.format('YYYY-MM-DD')
    },
    submit() {
      this.clearAllCart()
      this.$router.push({
        name: 'property-landing',
        query: {
          check_in: this.checkInDate,
          check_out: this.checkOutDate,
          promo_code: this.promotionCode,
        },
      })
    },
  },
}
</script>

<template>
  <div class="hidden md:flex flex-wrap items-end -mx-3">
    <div v-if="isMounted" class="w-1/2 sm:w-3/12 px-3 mb-3 md:mb-0">
      <label for="check-in" class="label">Check-in</label>
      <BaseDatepicker :value="checkInPlaceholder" :options="pickerOptions" />
    </div>
    <!-- check-in -->

    <div class="w-1/2 sm:w-3/12 px-3 mb-3 md:mb-0">
      <label for="check-in" class="label">Check-out</label>
      <input
        ref="secondField"
        :value="checkOutPlaceholder"
        type="text"
        class="input cursor-pointer"
      />
    </div>
    <!-- check-out -->

    <div class="w-1/2 sm:w-3/12 px-3 mb-3 md:mb-0">
      <label for="promotion-code" class="label">Promo code</label>
      <input v-model="promotionCode" type="text" class="input" />
    </div>
    <!-- promotion code -->

    <div class="w-1/2 sm:w-3/12 px-3 mb-3 md:mb-0">
      <button
        class="btn btn-gold"
        :class="{ 'btn-disabled': searching }"
        :disabled="searching"
        @click="submit"
      >
        {{ $route.name === 'property-landing' ? 'Search' : 'Change dates' }}
      </button>
    </div>
  </div>
</template>
